var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","justify":"center"}},[_c('v-card',[_c('v-card-title',[_c('h5',{staticClass:"text-center"},[_vm._v("Linking..."),_c('br'),_c('v-progress-circular',{attrs:{"small":"","color":"blue","indeterminate":""}})],1),_vm._v(" "+_vm._s(_vm.status)+" "+_vm._s(_vm.err)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }